import { useCallback, useContext } from "react";
import { ShellContext } from "../context";
import { ModuleInfo } from "../model";
import { resolvePath, useLocation } from "react-router";

/**
 * Gets a module path resolver function namespaced to the current owning module.
 */
export function useShellModulePathResolver(): /**
 * Returns a path relative to the root of the specified module.
 * @param module The module to derive a path from.
 * @param path The relative path.
 */
  (module: ModuleInfo, path: string) => string {
  let { moduleRootPath } = useContext(ShellContext);

  const location = useLocation();
  // const matches = useMatches();

  return useCallback(
    (module: ModuleInfo, path: string): string => {
      const { id } = module;

      let finalPath = path;
      if (!path.startsWith("/")) finalPath = `/${finalPath}`;
      if (finalPath === "/") finalPath = "";
      if (moduleRootPath === "/") moduleRootPath = "";

      return resolvePath(`${moduleRootPath}/${id}${finalPath}`, location.pathname).pathname;
    },
    [moduleRootPath],
  );
}
